import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import AccountTopBar from "./components/AccountTopBar";
import SideBar from "./components/SideBar/SideBar";
import { AppContext } from "service/AppContext";
import MobileTopBar from "./components/MobileTopBar";
import MobileNavBottom from "./components/mobileNavBottom/MobileNavBottom";
import { getBusinessReviews as getBusinessReviewsApi } from "api/businessReviewsApi";
import "./BusinessDashboard.scss";
import {CompanySpotState, fetchCompanySpot, selectCompanySpotState} from "features/business/companySpotSlice";
import {useAppDispatch, useAppSelector} from "app/hooks";
import {useIntercom} from "react-use-intercom";
import {getPaymentMethod, pickPlan} from "../../../api/paymentsApi";
import ResponsiveDialog from "../../../components/Modal";
import {logoutAsync} from "../../../features/business/companySlice";
import {CardElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {apiInstance} from "../../../api/api";

const BusinessDashboard = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { userInfo } = useContext<any>(AppContext);
  const { t, i18n } = useTranslation();
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const companySpotState = useAppSelector(selectCompanySpotState) as CompanySpotState;
  const companySpot  = companySpotState.data;

  const { boot, shutdown, hide,
    // update, isOpen
  } = useIntercom();

  useEffect(() => {
    boot({
      email: userInfo?.email,
      name: userInfo?.name,
      languageOverride: i18n.language,
    });

    return () => {
      shutdown();
    };
  }, [userInfo, i18n]);


  const [reviews, setReviews] = useState<any>(null);
  // const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [show, setShow] = useState(false);
  const [isInitialLogin, setIsInitialLogin] = useState(false);

  useEffect(() => {
    hide();
    setShow(false);
  }, [location]);

  const getBusinessReviews = async (spot_slug: string, page?: any) => {
    if (spot_slug) {
      // here some bug if we take spot_slug not from userInfo
      const data = await getBusinessReviewsApi(userInfo.spot_slug, page);
      return data.data;
    } else {
      return Promise.resolve(null);
    }
  };

  useEffect(() => {
    if (userInfo?.company_id) {
      let initDashLogin = localStorage.getItem('initDashLogin') || null

      if (initDashLogin) {
        const initDashLoginParsed = JSON.parse(initDashLogin)
        if (!initDashLoginParsed.includes(userInfo.company_id)) {
          initDashLoginParsed.push(userInfo.company_id)
          localStorage.setItem('initDashLogin', JSON.stringify(initDashLoginParsed))
          setIsInitialLogin(true)
        }
      } else {
        localStorage.setItem('initDashLogin', JSON.stringify([userInfo.company_id]))
        setIsInitialLogin(true)
      }
    }
  }, [userInfo?.company_id])

  useEffect(() => {
     if (userInfo?.spot_slug) {
       dispatch(fetchCompanySpot(userInfo?.spot_slug))
     }
  }, [userInfo?.spot_slug])

  useEffect(() => {
    if (userInfo?.spot_slug) {
      getBusinessReviews(userInfo?.spot_slug)
        .then((data) => {
          if (data) {
            setReviews(data);
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            console.log("getPaymentMethod error 401");
            navigate("/business/signin");
          }
        });
    }
  }, [userInfo]);

  useEffect(() => {
    getPaymentMethod()
      .then((data) => {})
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          console.log("getPaymentMethod error 401");
          navigate("/business/signin");
        } else {
          console.log("getPaymentMethod error", error);
          //TODO
          // setShowPaymentModal(true);
        }
      });
  }, []);

  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState<any>(null);


  return (
    <div className="dashboard">
      {
        companySpot?.tariff_id && <ResponsiveDialog
              open={showPaymentModal}
              title="Please, provide payment information"
              text={<div>
                <CardElement />
                <p style={{
                  color:'red'
                }} >
                  {error}
                </p>
              </div>}
              handleClose={() => {
                dispatch(logoutAsync());
                navigate("/business/signin");
              }}
              handleClick={async () => {
                if (!stripe || !elements) {
                  // Stripe.js has not yet loaded.
                  return;
                }

                const cardElement: any = elements.getElement(CardElement);

                const { token, error } = await stripe.createToken(cardElement);

                if (error) {
                  setError(error.message);
                } else {
                  const result = await apiInstance().patch("/api/payment-method/payment", { payment_method_token: token.id });

                  if (result.status === 200) {
                    setShowPaymentModal(false)
                  } else {
                    setError("Error updating payment method");
                  }
                }
              }}
          />
      }
      <SideBar/>
      <div className="dashboard-container">
        {isInitialLogin ? (
          <div className="header">
            <div className="viewing-block">
              Click here to start browsing
              
              <svg width="49" height="30" viewBox="0 0 49 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.78085 6.67865C1.41401 7.0915 0.781943 7.12879 0.369093 6.76195C-0.0437567 6.39511 -0.0810533 5.76304 0.285789 5.35019L1.78085 6.67865ZM20.3825 12.4399L20.0686 11.4905L20.3825 12.4399ZM25.2472 4.29235L24.3354 4.70296L25.2472 4.29235ZM18.7516 1.7167L18.4597 0.760261L18.7516 1.7167ZM14.0759 6.10151L15.0188 6.43455L14.0759 6.10151ZM16.1084 16.0172L15.3044 16.6117L16.1084 16.0172ZM29.4391 24.4098L29.3398 25.4049L29.4391 24.4098ZM47.8023 19.3408C48.3219 19.5279 48.5914 20.1008 48.4043 20.6205L45.3551 29.0882C45.1679 29.6078 44.595 29.8773 44.0754 29.6902C43.5558 29.5031 43.2862 28.9302 43.4733 28.4106L46.1838 20.8837L38.6569 18.1733C38.1373 17.9861 37.8678 17.4132 38.0549 16.8936C38.242 16.374 38.8149 16.1044 39.3346 16.2915L47.8023 19.3408ZM0.285789 5.35019C1.00351 4.54246 1.82222 4.04256 2.73755 3.86471C3.63874 3.6896 4.52828 3.84717 5.3631 4.16221C6.98352 4.77371 8.67034 6.09401 10.2785 7.36122C11.9485 8.67718 13.5967 9.99184 15.2837 10.843C16.9507 11.684 18.5209 12.0021 20.0686 11.4905L20.6963 13.3894C18.4524 14.1312 16.3066 13.5992 14.3828 12.6286C12.479 11.6681 10.6615 10.2094 9.04062 8.93211C7.35783 7.60608 5.92846 6.51323 4.65696 6.0334C4.04582 5.80278 3.54546 5.74513 3.11902 5.82799C2.70672 5.90811 2.26005 6.13935 1.78085 6.67865L0.285789 5.35019ZM20.0686 11.4905C21.7611 10.931 23.1414 9.83566 23.931 8.56967C24.7143 7.31371 24.8941 5.9436 24.3354 4.70296L26.1591 3.88173C27.0451 5.84928 26.6896 7.92585 25.628 9.62808C24.5725 11.3203 22.798 12.6947 20.6963 13.3894L20.0686 11.4905ZM24.3354 4.70296C23.4732 2.7883 21.1026 2.04463 19.0436 2.67313L18.4597 0.760261C21.1869 -0.072206 24.7683 0.793479 26.1591 3.88173L24.3354 4.70296ZM19.0436 2.67313C16.7539 3.37205 15.4435 5.232 15.0188 6.43455L13.1329 5.76848C13.7187 4.10998 15.4311 1.68471 18.4597 0.760261L19.0436 2.67313ZM15.0188 6.43455C13.9821 9.36963 15.1729 13.0698 16.9125 15.4227L15.3044 16.6117C13.3462 13.9633 11.7919 9.56524 13.1329 5.76848L15.0188 6.43455ZM16.9125 15.4227C19.9057 19.4708 23.8557 22.8476 29.5384 23.4147L29.3398 25.4049C22.8733 24.7595 18.4727 20.8968 15.3044 16.6117L16.9125 15.4227ZM29.5384 23.4147C33.6743 23.8275 40.2434 22.5734 47.0377 19.3768L47.8892 21.1865C40.8932 24.478 33.9523 25.8652 29.3398 25.4049L29.5384 23.4147Z" fill="#F1F1F1"/>
              </svg>

              <a href="/business/dashboard" className="viewing">
                viewing
              </a>
            </div>
            <div className="welcome-message">
              <span>{t("welcome-message-dashboard-title")}</span>
              <span>{t("welcome-message-dashboard-content")}</span>
            </div>
          </div>
        ): null}
        <div className={isInitialLogin ? "dashboard-inner-container" : ""}>
            <AccountTopBar  rate={reviews?.average_rating} show={show} setShow={setShow} />
            <MobileTopBar rate={reviews?.average_rating} show={show} setShow={setShow} />
            <div className="active-component-container">
              <Outlet/>
            </div>
        </div>
      </div>
      <MobileNavBottom/>
    </div>
  );
};

export default BusinessDashboard;
